// extracted by mini-css-extract-plugin
export default {"button":"style_button__ox3WD","processing":"style_processing__VLxpM","loader":"style_loader__DxjYT"};